import { emailRegExp, trimText } from 'utils';
import localization from '../localization';
import { validatePhoneNum, validateName } from '../utils';

export default {
    name: {
        isValid: (name) => validateName(name),
        message: (lang) => localization[lang].common_errors.name
    },
    phoneNumber: {
        isValid: (phone) => validatePhoneNum(phone),
        message: (lang) => localization[lang].common_errors.phone
    },
    email: {
        isValid: (email) => emailRegExp(trimText(email)),
        message: (lang) => localization[lang].common_errors.valid_email
    },
    relationship: {
        isValid: (name) => trimText(name).length > 1,
        message: (lang) => localization[lang].contacts_errors.relationship
    }
};
